module.exports = require('./lib/styleable')


//////////////////
// WEBPACK FOOTER
// ./~/react-styleable/index.js
// module id = 81
// module chunks = 4